import { Component, OnInit, Input, inject } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ModalController } from '@ionic/angular';
import { VideomodalComponent } from '../../components/videomodal/videomodal.component'
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-videobutton',
    templateUrl: './videobutton.component.html',
    styleUrls: ['./videobutton.component.scss'],
    standalone: false
})
export class VideobuttonComponent implements OnInit {
  @Input() video: any;

  private api = inject(ApiService);

  constructor(public modalController:ModalController, public data: DataService) { }

  ngOnInit() {}

  select_(){
    console.log(this.video)
  }

  async select(){
    let that = this
    const modal = await this.modalController.create({
      component: VideomodalComponent,
      animated: true,
      cssClass: 'exercise-modal-shell',
      htmlAttributes: { 'aria-label': 'Video: ' + (that.video?.title || '') },
      componentProps: {
        video: that.video,
        basepath: that.api.getMediaBase(),
      }
    });

    let payload = {
      token: this.data.token,
      title: 'Open video '+this.video.title,
      pathway_id: that.data.pathway ? that.data.pathway.id : '',
      condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
    };
    void this.data.apiPost('userappnav', payload);
    return await modal.present();
  }

  get thumbpath(){
    return encodeURI(this.api.mediaUrl(this.video.thumb));
  }
}